/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TicketStatusSearch = 0 | 1 | 2 | 3;

export const TicketStatusSearch = {

    NUMBER_0: 0 as TicketStatusSearch,

    NUMBER_1: 1 as TicketStatusSearch,

    NUMBER_2: 2 as TicketStatusSearch,

    NUMBER_3: 3 as TicketStatusSearch
};

